/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'vh-match-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const rulesLabel = `${prefix}.rulesLabel`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Host',
    [modalTitleNew]: 'New Host',
    [rulesLabel]: 'Rules ({0})',
};
